import { ACTION_SUBJECT_PREFIX, EVENT_SOURCE } from '../../constants/analytics';
import { type FireAnalyticsEvent } from '../../types';

type ThirdPartyQuerySuggestionsShownArgs = {
	productKey: string;
};

export const onThirdPartyQuerySuggestionsShown = ({
	productKey,
}: ThirdPartyQuerySuggestionsShownArgs): FireAnalyticsEvent => ({
	source: EVENT_SOURCE,
	eventType: 'track',
	actionSubject: `${ACTION_SUBJECT_PREFIX}ThirdPartyQuerySuggestions`,
	action: 'shown',
	attributes: {
		additionalAttributes: {
			productKey,
		},
	},
});
